export default "__VITE_ASSET__Cr4lri8b__"